import { render, staticRenderFns } from "./BlockFeaturedVideo.vue?vue&type=template&id=05810b03&scoped=true&"
import script from "./BlockFeaturedVideo.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedVideo.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedVideo.vue?vue&type=style&index=0&id=05810b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05810b03",
  null
  
)

export default component.exports